import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token') || null);

  // Keep localStorage in sync if token changes
  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }, [token]);

  const login = (newToken) => {
    setToken(newToken);
  };

  const logout = async () => {
    try {
        // You must send the current token as an auth header:
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/logout/`, null, {
          headers: {
            Authorization: `Token ${token}`,
          },
        });
      } catch (err) {
        console.error(err);
        // If it fails, that might be okay—we'll still remove local token
      }
      
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
